import React from "react";
import { Outlet } from "react-router-dom";
import { Navbar, MobileBottomNav } from "./Navbar";
import { Footer } from "./Footer";

export const PublicLayout = () => {
    return (
        <div className="flex flex-col min-h-screen bg-background">
            <Navbar />
            <main className="flex-1 pb-20 md:pb-0">
                <Outlet />
            </main>
            <Footer />
            <MobileBottomNav />
        </div>
    );
};
